<template>
  <card class="mailing-list-sms custom-header">
    <div slot="header" class="card-text">
      <h4 class="card-title">
        {{ title }} рассылки
      </h4>
    </div>
    <div
      v-loading="loading"
      :element-loading-text="`Загрузка ${title.toLowerCase()} рассылок...`"
      class="mailing-list-content">
      <div
        v-for="service in listServices"
        :key="service"
        class="mailing-list-item"
        :class="{'update-mailing': loadingMailing === service}">
        <img :src="`/static/img/icons/${service}_logo.png`" :alt="`logo ${service}`">
        <fg-input>
          <el-select
            v-model="model[service]"
            v-loading="loadingMailing === service"
            @change="value => handleChangeMailing({service, value})">
            <el-option
              v-for="(titleAction, aliasAction) in mailingList.list[service]"
              :key="aliasAction"
              :value="aliasAction"
              :label="titleAction"/>
          </el-select>
        </fg-input>
      </div>
      <p v-if="!loading && !mailingList.selected" class="empty-text-mailing">
        {{ title }} рассылки не найдены.
      </p>
    </div>
  </card>
</template>

<script>
import { ElOption, ElSelect } from 'element-plus'

export default {
  name: "MailingCard",
  components: {
    ElSelect,
    ElOption
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    mailingList: Object,
    actionForGetData: Function,
    actionForUpdateData: Function,
  },
  data() {
    return {
      model: [],
      loading: null,
      loadingMailing: undefined
    }
  },
  computed: {
    listServices() {
      return Object.keys(this.mailingList.selected || {})
    }
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        await this.actionForGetData({
          type: this.title.toLowerCase(),
          url: this.url
        })
      } finally {
        this.loading = false
      }
    },
    async handleChangeMailing(payload) {
      const {service} = payload
      this.loadingMailing = service
      await this.actionForUpdateData({
        ...payload,
        type: this.title.toLowerCase(),
        url: this.url
      })
      this.loadingMailing = undefined
    }
  },
  async beforeMount() {
    await this.getData()
    for (const [service, value] of Object.entries(this.mailingList.selected)) {
      this.model[service] = value
    }
  }
}
</script>

<style scoped>

</style>
